import { http, RxHttp } from "@rxweb/http";
import { IFormGroup } from '@rxweb/reactive-form-validators';
import { EmailNotification } from '@app/models';
import { CoreComponent } from '@rxweb/angular-router';
import { BaseDialog } from 'src/app/domain/customize-design/dialog';
import { BaseToastr } from 'src/app/domain/customize-design/toastr';
import { BreadCrumb } from 'src/app/viewModel/bread-crumb';
import { Query } from "src/app/viewModel/sp-parameter";

@http({
    path:'api/EmailNotification'
})

export class AbstractEmailNotification extends CoreComponent {
    emailNotificationFormGroup: IFormGroup<EmailNotification>
    toastr: BaseToastr;
    spin = false;
    breadCrumb: BreadCrumb;
    dialog: BaseDialog;
    showComponent: boolean = false;
    rxHttp: RxHttp;

    constructor() {
        super();
        this.bindBreadCrumb();
        this.toastr = new BaseToastr();
        this.dialog = new BaseDialog();
        this.rxHttp = new RxHttp();
        this.badRequest;
    }
    bindBreadCrumb() {
        this.breadCrumb = new BreadCrumb();
        this.breadCrumb.link1 = 'dashboard';
        this.breadCrumb.name1 = "Home";
        // this.breadCrumb.name2="Email Notification";
        this.breadCrumb.title = 'Email Notifications';
        this.breadCrumb.pageName = 'Email Notifications';
        this.breadCrumb.pageRedirect = "email-notification";
        // this.breadCrumb.title = 'Email Notification';
    }
    badRequest = (data) => {
        this.spin = false;
        let messages = JSON.parse(data);
        this.toastr.warning(messages[0]);
    }

    getEmailNotifications(searchParams: Query) {
        return this.rxHttp.post({ body: searchParams, path: 'api/EmailNotification/getEmailNotifications' });
    }
}
